// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3B_mW","description":"PatientConsentPreview_description__3DBFW"};